"use client";

import { cn } from "@/lib/utils";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, VariantProps } from "class-variance-authority";
import * as React from "react";

const labelVariants = cva(
  "tw-body-2-m tw-inline-block peer-disabled:tw-pointer-events-none peer-disabled:tw-text-gray-500 tw-mb-0",
);

export const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants({ className }))}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;
